<template>
  <div>
    <div class="menu" id="menu">
      <div class="content1">
        <!-- <div class="logo">
          <router-link to="/">千种药用植物基因组数据库</router-link>
        </div> -->
        <div class="btn">
          <!-- <el-menu class="el-menu-demo" mode="horizontal">
            <el-menu-item index="1" class="black"><router-link to="/">Home</router-link></el-menu-item>
            <span></span>
            <el-menu-item index="3"><router-link to="/blastcenter">Blast</router-link></el-menu-item>
             <el-menu-item index="4">|</el-menu-item>
            <el-menu-item index="5"><router-link to="/primer">Primer design</router-link> </el-menu-item>
            <el-menu-item index="3"><router-link to="/download">Download</router-link></el-menu-item> 
          </el-menu> -->
          <ul>
            <li class="black"><router-link to="/">Home</router-link></li>
            <li class="ww">|</li>
            <li><router-link to="/blastcenter">Blast</router-link></li>
            <li class="ww">|</li>
            <li><router-link to="/primer">Primer design</router-link></li>
          </ul>
        </div>
      </div>
    </div>
    <div class="content">
      <h3></h3>
      <div class="explain">
        <p v-html="resultData.description"></p>
      </div>
      <div class="img">
        <table class="tab" cellpadding="0" cellspacing="0">
          <thead>
            <tr class="bg">
              <th>Family</th>
              <th>Genus</th>
              <th>Species</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in resultData.list" :key="index">
              <td>
               <router-link
                  :to="{ path: '/family', query: { familyId: item.familyid } }"
                  >{{ item.family }}</router-link
                >
              </td>
              <td>
                <router-link
                  :to="{ path: '/genus', query: { genusId: item.genusid } }"
                  >{{ item.genus }}</router-link
                >
              </td>
              <td>
                <a @click="searchPlant(item.special)">{{ item.special }}</a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      resultData: "",
    };
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
    let token=localStorage.getItem("authorization");
      if(token=="" || token==null){
         this.$alert("Login expired, please log in again", "Notice", {
              confirmButtonText: 'Confirm',
              callback: (action) => {
                 that.$router.push("/login");
              },
            });
        return false;
      }
    let familyId = this.$route.query.familyId;
    //console.log(familyId);
    if (familyId == "" || familyId == null) {
      this.$router.push("/");
    } else {
      this.getFamily(familyId);
    }
  },
  methods: {
    handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      let offsetTop = document.querySelector("#menu").offsetTop;
      let isFixed = scrollTop > offsetTop ? true : false;
      if (isFixed) {
        document.querySelector("#menu").style =
          "position: fixed;top:0;background:#fff;z-index:9999";
      } else {
        document.querySelector("#menu").style = "";
      }
    },
    searchPlant(plant) {
      let that = this;
      let token=localStorage.getItem("authorization");
      axios
        .get("/bena/server/gooal/genome/search?name=" + plant,{
          headers: { Authorization: token },
        })
        .then(function (response) {
          //console.log(response);
          if (response.data.code == 0) {
            //that.tableData = response.data.result;
            if (response.data.result.length > 0) {
              if (response.data.result[0].did) {
                that.$router.push(
                  "/species?did=" +
                    response.data.result[0].did +
                    "&latin_name=" +
                    response.data.result[0].latinName +
                    "&plant_name=" +
                    response.data.result[0].plantName+
                    "&id=" +
                    response.data.result[0].id
                );
              }
            } else {
              that.$alert("Sorry, no results were found！", "Notice", {
                confirmButtonText: 'Confirm',
                callback: (action) => {},
              });
            }
          } else {
            that.$alert("Loading failed！" + response.data.msg, "Notice", {
              confirmButtonText: 'Confirm',
              callback: (action) => {},
            });
          }
        })
        .catch(function (error) {
          that.$message.error("失败!");
          //console.log(error);
        });
    },
    getFamily(familyId) {
      let that = this;
      let token=localStorage.getItem("authorization");
      axios
        .get("/bena/server/gooal/genome/getbyfamilyid?id=" + familyId,{
          headers: { Authorization: token },
        })
        .then(function (response) {
          //console.log(response);
          if (response.data.code == 0) {
            that.resultData = response.data.result;
          } else {
            that.$alert("Loading failed！" + response.data.msg, "Notice", {
              confirmButtonText: 'Confirm',
              callback: (action) => {},
            });
          }
        })
        .catch(function (error) {
           that.$alert("Loading failed！" + error.response.data.message, "Notice", {
            confirmButtonText: 'Confirm',
            callback: (action) => {
               return false;
            },
          });
          //that.$message.error("失败!");
          //console.log(error);
        });
    },
  },
};
</script>

<style scoped>
.menu {
  width: 100%;
  height: 60px;
  flex: 0;
  border-bottom: 1px solid #ccc;
  margin-bottom: 10px;
  box-shadow: 1px 1px 2px #ccc;
}
.menu .content1 {
  width: 1200px;
  height: 50px;
  margin: 0 auto;
  /* border: 1px solid red; */
}
.menu .black {
  color: #000;
}
.menu .content1 .logo {
  float: left;
  width: 250px;
  height: 50px;
  margin: 5px 0;
  /* border: 1px solid #ccc; */
  line-height: 50px;

  text-align: center;
}
.menu .content1 .logo a {
  text-decoration: none;
  font-size: 20px;
  color: seagreen;
  font-weight: bold;
}
.menu .content1 .btn {
  /* float: right; */
  width: auto;
}
.menu .content1 .btn ul {
  margin: 0;
  padding: 0;
  list-style: none;
}
.menu .content1 .btn ul li {
  float: left;
  padding: 0 20px;
  line-height: 50px;
}
.menu .content1 .btn ul li.ww {
  color: #ccc;
}
.menu .content1 .btn ul li a {
  text-decoration: none;
  color: #333;
  font-size: 14px;
}
.menu .content1 .btn ul li:nth-child(1) a {
  color: #000;
  font-weight: 700;
}
.menu .content1 .btn .el-menu.el-menu--horizontal {
  border: none;
}
.content {
  width: 1200px;
  min-height: 780px;
  margin: 10px auto;
  overflow: auto;
  background-color: #eee;
}
h3 {
  margin-left: 30px;
  color: seagreen;
}
.explain {
  margin: 0 30px 0 30px;
  background-color: #fff;
  padding: 10px;
}

p {
  text-indent: 2em;
  line-height: 25px;
  letter-spacing: 0px;
  color: rgb(33, 43, 36);
  font-family: Microsoft YaHei;
  font-size: 14px;
}
.img {
  margin: 30px auto 10px;
}
img {
  display: block;
  margin: 0 auto;
}
.tab {
  /* border: 1px solid red; */
  margin: 0 30px;
  width: 1140px;
}
.tab thead tr {
  background: seagreen;
  color: #fff;
}
.tab .tr,
th {
  border: 1px solid #ccc;
  text-align: center;
  line-height: 25px;
  padding: 5px;
}
.tab .tr,
td {
  border: 1px solid #ccc;
  text-align: center;
  line-height: 25px;
  padding: 5px;
}
.tab tr td a{
  color: seagreen;
  text-decoration: none;
  cursor: pointer;
}
</style>>